import { render, staticRenderFns } from "./caymus-vineyards.vue?vue&type=template&id=5790a93e&scoped=true"
import script from "./caymus-vineyards.vue?vue&type=script&lang=js"
export * from "./caymus-vineyards.vue?vue&type=script&lang=js"
import style0 from "./caymus-vineyards.vue?vue&type=style&index=0&id=5790a93e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5790a93e",
  null
  
)

export default component.exports